import React from 'react';
import { Grid, Stack } from '@mui/material';
import InputLabel from 'components/form/InputLabel';
import OutlinedInput from 'components/form/OutlinedInput';

const DadosIntegracao = ({ formProps, disabled }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <Stack spacing={1}>
          <InputLabel htmlFor="codigoIntegracaoBradesco">Código de Integração Bradesco</InputLabel>
          <OutlinedInput
            disabled={disabled}
            name="codigoIntegracaoBradesco"
            placeholder="Código de Integração Bradesco"
            fullWidth
            required
            formProps={formProps}
          />
        </Stack>
      </Grid>
    </Grid>
  );
};

export default DadosIntegracao;
